module.exports = __webpack_public_path__ + "static/media/link-active-icon.5ea07e01.svg";